/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
import {
  post as postAxios,
  put as putAxios,
  get as getAxios,
} from "../apiHandler";

const endPoint = process.env.REACT_APP_API_BASE_URL;
const PAGE_SIZE = 10;

const post = (url, { accessToken, data, params }) =>
  postAxios(url, { accessToken, data, endPoint, params });
const put = (url, { accessToken, data, params }) =>
  putAxios(url, { accessToken, data, endPoint, params });
const get = (url, { data, accessToken }) =>
  getAxios(url, { data, accessToken, endPoint });

export default class ControlPanelAPI {
  static syncRolesAndPermission() {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/migrations/rolePermissions`, {
      accessToken: accessTokenFromLocal,
    });

    ControlPanelAPI.syncRolesAndPermission.cancel = request.cancel;
    return request;
  }

  static emailUnmarkedStructures() {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/meetings/unmarked/structures`, {
      accessToken: accessTokenFromLocal,
    });

    ControlPanelAPI.emailUnmarkedStructures.cancel = request.cancel;
    return request;
  }

  static createNewSetting(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/settings`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    ControlPanelAPI.createNewSetting.cancel = request.cancel;
    return request;
  }

  static updateSetting(id, data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(`/api/settings/${id}`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    ControlPanelAPI.updateSetting.cancel = request.cancel;
    return request;
  }

  static getSettingByID() {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/settings`, {
      accessToken: accessTokenFromLocal,
    });

    ControlPanelAPI.getSettingByID.cancel = request.cancel;
    return request;
  }

  static async getAllSettings() {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    try {
      const response = await get(`/api/settings`, {
        accessToken: accessTokenFromLocal,
      });
      return response;
    } catch (err) {
      console.error("Error fetching settings:", err);
      throw err;
    }
  }
}
